<template>
    <div>
      <!-- Pasa la prop solo si la copia está completa -->
      <TableComponent v-if="isCopyComplete" :items="localItemsArray" :columns="columns" @nextModalAnulados="nextModalAnulados" ref="tableData" />
    </div>
  </template>

<script>
import TableComponent from './table2.vue'

export default {
  components: {
    TableComponent,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      columns: ['ID Banner', 'Cédula', 'Nombres', 'Documento', 'Número Orden','Período', 'Operador', 'Anulado ID_Banner', 'Anulado Periodo ID_Banner', '¿Es Anulado?'],
      localItemsArray: [],
      isCopyComplete: false, // Indica si se completó la copia
    }
  },
  mounted () {
    this.localItems() 
  },
  methods: {
    localItems () {
      this.localItemsArray = this.items.map(item => ({
        ...item, // Copia las propiedades existentes
        esAnulado: '', // Añade la nueva propiedad
      }))
      this.isCopyComplete = true // Marca que la copia se completó
    },
    callTableSon () {
      this.$refs.tableData.sendDataOperators()
    },
    nextModalAnulados(){
      this.$emit('nextModalAnulados')
    }
  },
}
</script>